import styled from 'styled-components';
import theme from '../../styled/shared/Theme';

const StyledInstructions = styled.div`
  color: ${theme.white};
  text-align: center;
  font-size: 18px;
  padding-bottom: ${theme.spacingL};
`;

export default StyledInstructions;
